module.exports = __webpack_public_path__ + "media/images/metronic/social/rss-9a1390b60083f6190e6a5175f78e14fc.png";